import { createAction, createSlice } from "@reduxjs/toolkit";

const myTotalEnrollmentSlice = createSlice({
  name: "myTotalEnrollment",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = myTotalEnrollmentSlice;
const myTotalEnrollmentAction = createAction(name);

export {
  myTotalEnrollmentAction,
  actions as myTotalEnrollmentActions,
  reducer as myTotalEnrollmentReducer,
};
